import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MwcIconModule } from 'mwc/icon';
import { Router } from '@angular/router';
import { ModeratorRedirectService } from '../services/moderation/moderator-redirect.service';

/**
 * Full-page interstitial shown to a Moderator of the moderation workflow. Their work
 * happens in MPC's approval management rather than in Content Studio, so the app tells them where
 * they are going and sends them there after a short pause.
 *
 * No actions: no button, no dismiss — it redirects on its own. Reached via the /approval-redirect
 * route, which AuthGuard sends moderators to (see ModeratorRedirectService).
 */
@Component({
  selector: 'app-approval-redirect',
  standalone: true,
  imports: [CommonModule, MwcIconModule],
  templateUrl: './approval-redirect.component.html',
  styleUrls: ['./approval-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalRedirectComponent implements OnInit, OnDestroy {
  /** How long the message stays up before the browser leaves for MPC. */
  private static readonly REDIRECT_DELAY_MS = 3000;

  private redirectTimer: any;

  constructor(
    private moderatorRedirectService: ModeratorRedirectService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const url = this.moderatorRedirectService.approvalManagementUrl;
    if (!url) {
      // Nothing to redirect to (no MPC base url) — don't strand the user on this screen.
      this.router.navigate(['/dashboard']);
      return;
    }
    this.redirectTimer = setTimeout(() => {
      window.location.href = url;
    }, ApprovalRedirectComponent.REDIRECT_DELAY_MS);
  }

  ngOnDestroy(): void {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }
}
